import { isEmpty, sortBy } from "lodash";
import { useTranslation } from "react-i18next";

import { Select } from "@krea/common/shared-components/fields/select/";
import { useGetUserData } from "@krea/common/store/user/hooks/queries";

export const CampaignInput = ({
  value,
  touched,
  errors,
  label,
  onChange,
}: {
  value: string;
  touched: boolean;
  errors: string;
  label: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}) => {
  const { t } = useTranslation();
  const { data: user = {} } = useGetUserData();

  const utmCampaigns = user.partnerOrganisation?.utmCampaigns;
  const sortedCampaigns = sortBy(utmCampaigns);

  if (isEmpty(utmCampaigns)) {
    return null;
  }

  return (
    <Select
      name="utm_campaign"
      size="lg"
      id="utm_campaign"
      label={label || t("applicationForm.campaignLabel")}
      value={value || ""}
      error={touched && errors ? errors : null}
      onChange={onChange}
    >
      <option value="">{t("applicationForm.campaignPlaceholder")}</option>

      {sortedCampaigns.map((item) => {
        return (
          <option value={item} key={item}>
            {item}
          </option>
        );
      })}
    </Select>
  );
};
